import React, { useState, useEffect } from "react";
import './bannerwebsitemanagment.scss'

import { Link, NavLink, useHistory } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Offcanvas from "react-bootstrap/Offcanvas";
import Dropdown from "react-bootstrap/Dropdown";

import Environment from "utils/environment";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";



const Bannerwebsitemanagment = () => {
    const [image, setImage] = useState("");
    const [baseImage, setBaseImage] = useState("");
    const [accountImage, setAccountImage] = useState();

    const val = localStorage.getItem("accessToken");
const BAS_URL = Environment.base_url2

    const [show, setShow] = useState(false);
    const [show1, setShow1] = useState(false);
    // const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    // const handleClose1 = () => setShow(false);
    const handleShow1 = () => setShow1(true);
    const [isUploading, setIsUploading] = useState(false);
    const [bannerData, setBannerData] = useState([]);
    const [newImageFile, setNewImageFile] = useState(null);
    const [newBaseImage, setNewBaseImage] = useState(null);
    const [editingBanner, setEditingBanner] = useState(null);
    const [newBannerLink, setNewBannerLink] = useState('');
    const [newBannerTitle, setNewBannerTitle] = useState('');
    const [newBannerType, setnewBannerType] = useState('');


    const convertBase645 = (file) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = () => {
                resolve(fileReader.result);
            };
            fileReader.onerror = (error) => {
                reject(error);
            };
        });
    };

    const uploadImages = async (e) => {
        const file = e.target.files[0];
        const base64 = await convertBase645(file);
        setBaseImage(base64);
        setImage(file);
    };

    /////
    const handleClose = () => {
        setShow(false);
        resetForm();
    };

    const handleClose1 = () => {
        setShow1(false);
        resetForm();
    };

    const resetForm = () => {
        setNewImageFile(null);
        setNewBaseImage(null);
        setNewBannerLink('');
        setEditingBanner(null);
    };


    const fetchBanners = async () => {
        try {
            const response = await axios.get(`${BAS_URL}/banners?limit=100&offset=1&filter=device=eq:web`, {
                headers: {
                    Authorization: "Bearer " + val,
                },
            });
            if (response.data.data && response.data.data.banners) {
                setBannerData(response.data.data.banners);
            }
        } catch (error) {
            console.error("Error fetching banners:", error);
        }
    };

    useEffect(() => {
        fetchBanners();
    }, []);


    // Filter banners into their respective groups based on your logic
    const firstItemBanners = bannerData
        .filter(item => item?.type?.trim() === 'main banner 1' || item?.type?.trim() === 'main banner 2')
        .slice(0, 2);

    const secondItemBanners = bannerData
        .filter(item => item?.type?.trim() === 'main banner 3' || item?.type?.trim() === 'main banner 5')
        .slice(0, 2);

    // Assuming 'second-item..' was a typo for 'third-item' based on your JSX structure
    const thirdItemBanners = bannerData
        .filter(item => item?.type?.trim() === 'main banner 4' || item?.type?.trim() === 'main banner 6')
        .slice(0, 2);


                const forItemBanners = bannerData
                 .filter(item => item?.type?.trim() === 'main banner 7' || item?.type?.trim() === 'main banner 8')
        .slice(0, 2);


        // Example JSON data for banners with image link and title
        // const bannersJson = [
        //     {
        //         "imageUrl": "http://localhost:3000/assets/dummy-imgs/ramadan2.webp",
        //         "title": "Main Banner 1"
        //     },
        //     {
        //         "imageUrl": "https://example.com/banner2.jpg",
        //         "title": "Main Banner 2"
        //     },
        //     {
        //         "imageUrl": "https://example.com/banner3.jpg",
        //         "title": "Main Banner 3"
        //     }
        // ];

        // // Existing code
        // const forItemBanners = bannersJson
        //     // .filter(item => item?.type?.trim() === 'main banner 7')
        //     // .slice(0, 2);




    const uploadNewBanner = async () => {
        // if (!newImageFile || !newBannerLink || !newBannerTitle) {
        //     toast.error("Please fill all fields.");
        //     return;
        // }

        setIsUploading(true);

        const formData = new FormData();
        formData.append('bannerLink', newBannerLink);
        formData.append('title', newBannerTitle);

        formData.append('type', newBannerType);
        formData.append('device', 'web');
        formData.append('bannerImage', newImageFile);


        try {
            const response = await axios.post(
                `${BAS_URL}/banners`,
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + val,
                    },
                }
            );
            toast.success('New banner uploaded successfully!');
            window.location.reload();
        } catch (error) {
            console.error('New Banner Upload Failed:', error);
            toast.error('Banner upload failed!');
            setNewBannerLink('');
            setNewImageFile(null);
            setNewBaseImage(null);
        } finally {
            setIsUploading(false);
        }
    };



    const handleUpdateBanner = async () => {
        if (!editingBanner || !editingBanner.id) return;

        const formData = new FormData();
        formData.append('bannerLink', newBannerLink);
        formData.append('type', newBannerType);
        formData.append('title', newBannerTitle);

        if (newImageFile) {
            formData.append('bannerImage', newImageFile);
        }
        formData.append('isPublish', 'true');

        try {
            await axios.patch(
                `${BAS_URL}/banners/${editingBanner.id}/is-publish`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${val}`,
                    },
                }
            );
            toast.success("Banner updated successfully!");
            window.location.reload();
        } catch (error) {
            console.error("Error updating banner:", error);
            toast.error("Failed to update banner.");
        }
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setNewImageFile(file);
            setNewBaseImage(URL.createObjectURL(file));
            setEditingBanner((prev) => ({ ...prev, newImageFile: file }));
        }
    };

    // --- Banner Deletion (DELETE) ---
    // const handleDeleteBanner = async (bannerId) => {
    //          try {
    //             await axios.delete(`https://prod-api.quick.shop/auth/banners/${bannerId}`, {
    //                 headers: {
    //                     Authorization: "Bearer " + val,
    //                 },
    //             });
    //             toast.success("Banner deleted successfully!");
    //             window.location.reload(); 
    //         } catch (error) {
    //             console.error("Error deleting banner:", error);
    //             toast.error("Failed to delete banner.");
    //         }
    //  };

    return (
        <>




            <h1 className='headerbannerwebsitemanagment'>Website Banner</h1>
            <div className="bannerwebmainsite">
                {/* ////  this is UI  */}
                {firstItemBanners.length > 0 && (
                    <div className="firstrowbannerweb">
                        <div className="image-wrapper2nd" style={{ position: "relative" }}>
                            <img className="img-fluid imginnerchldsss imgone " src={firstItemBanners[0].imageUrl} alt="" />
                            <div className="top-left-text">
                                <h4>{firstItemBanners[0].title}</h4>
                                <a href={firstItemBanners[0].bannerLink} className="shop-link">Shop Now
                                    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="22" viewBox="0 0 23 22" fill="none">
                                        <path d="M9.69998 15.3L14.2 10.8L9.69998 6.30005" stroke="#000" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </a>
                            </div>
                            <button
                                    onClick={() => {
                                        setEditingBanner(firstItemBanners[0]); // Set the banner to be edited
                                        setNewBannerLink(firstItemBanners[0].bannerLink); // Prefill the link
                                        setNewBaseImage(firstItemBanners[0].imageUrl); // Show the current image
                                        setNewBannerTitle(firstItemBanners[0].title); // Prefill the title
                                        setnewBannerType('main banner 1'); // Prefill the type
                                        handleShow1(); // Open the second Offcanvas
                                    }}
                                    className="edit-icon"
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                        <path d="M20.817 22.5728H3.15498C2.75268 22.5728 2.41907 22.2391 2.41907 21.8368C2.41907 21.4345 2.75268 21.1009 3.15498 21.1009H20.817C21.2193 21.1009 21.5529 21.4345 21.5529 21.8368C21.5529 22.2391 21.2193 22.5728 20.817 22.5728Z" fill="#CACACA" />
                                        <path d="M18.8742 4.40057C16.9706 2.497 15.1063 2.44794 13.1536 4.40057L11.9664 5.58785C11.8683 5.68597 11.829 5.84296 11.8683 5.98034C12.614 8.58057 14.6942 10.6608 17.2944 11.4065C17.3336 11.4163 17.3729 11.4261 17.4121 11.4261C17.5201 11.4261 17.6182 11.3869 17.6967 11.3084L18.8742 10.1211C19.8456 9.15949 20.3166 8.22733 20.3166 7.28536C20.3264 6.31395 19.8554 5.37198 18.8742 4.40057Z" fill="#CACACA" />
                                        <path d="M15.5282 12.2994C15.2436 12.162 14.9689 12.0246 14.7039 11.8677C14.4881 11.7401 14.282 11.6027 14.076 11.4555C13.9092 11.3476 13.7129 11.1906 13.5265 11.0336C13.5069 11.0238 13.4382 10.9649 13.3597 10.8864C13.0359 10.6117 12.6728 10.2585 12.349 9.86596C12.3196 9.84634 12.2705 9.77765 12.2018 9.68934C12.1037 9.5716 11.9369 9.37535 11.7897 9.14967C11.672 9.00249 11.5346 8.78662 11.407 8.57075C11.25 8.30582 11.1127 8.04089 10.9753 7.76615C10.9645 7.74294 10.9538 7.7198 10.9434 7.69672C10.7821 7.34139 10.3174 7.23676 10.0415 7.51267L4.46981 13.0844C4.34226 13.2119 4.22451 13.4572 4.19507 13.624L3.66521 17.3821C3.56709 18.0493 3.75352 18.6773 4.16564 19.0992C4.51888 19.4427 5.00948 19.6291 5.53934 19.6291C5.65709 19.6291 5.77484 19.6193 5.89258 19.5997L9.66047 19.0698C9.83709 19.0404 10.0824 18.9226 10.2001 18.7951L15.7642 13.231C16.042 12.9532 15.9374 12.4757 15.5766 12.3203C15.5605 12.3134 15.5444 12.3064 15.5282 12.2994Z" fill="#CACACA" />
                                    </svg>

                                </button>
                        </div>
                        {firstItemBanners.length > 1 && (
                            <div className="image-wrapper2nd" style={{ position: "relative" }}>
                                <img className="img-fluid imginnerchldsss imgtwo" src={firstItemBanners[1].imageUrl} alt="" />
                                <div className="top-left-text">
                                    <h4>{firstItemBanners[1].title}</h4>
                                    <a href={firstItemBanners[1].bannerLink} className="shop-link">Shop Now
                                        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="22" viewBox="0 0 23 22" fill="none">
                                            <path d="M9.69998 15.3L14.2 10.8L9.69998 6.30005" stroke="#000" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </a>
                                </div>
                                {/* <span className="edit-icon"><svg onClick={() => {
                                    setShow(true);
                                }} xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                    <path d="M20.8873 22.5727H3.22536C2.82306 22.5727 2.48944 22.239 2.48944 21.8367C2.48944 21.4344 2.82306 21.1008 3.22536 21.1008H20.8873C21.2896 21.1008 21.6232 21.4344 21.6232 21.8367C21.6232 22.239 21.2896 22.5727 20.8873 22.5727Z" fill="#CACACA" />
                                    <path d="M18.9445 4.40048C17.041 2.49691 15.1767 2.44785 13.224 4.40048L12.0367 5.58776C11.9386 5.68588 11.8994 5.84287 11.9386 5.98024C12.6844 8.58048 14.7645 10.6607 17.3648 11.4064C17.404 11.4162 17.4433 11.426 17.4825 11.426C17.5905 11.426 17.6886 11.3868 17.7671 11.3083L18.9445 10.121C19.9159 9.1594 20.3869 8.22724 20.3869 7.28527C20.3967 6.31386 19.9258 5.37189 18.9445 4.40048Z" fill="#CACACA" />
                                    <path d="M15.5985 12.2995C15.314 12.1621 15.0392 12.0247 14.7743 11.8677C14.5584 11.7402 14.3524 11.6028 14.1463 11.4556C13.9795 11.3477 13.7833 11.1907 13.5969 11.0337C13.5772 11.0239 13.5085 10.965 13.43 10.8865C13.1062 10.6118 12.7432 10.2585 12.4194 9.86603C12.39 9.8464 12.3409 9.77772 12.2722 9.68941C12.1741 9.57166 12.0073 9.37541 11.8601 9.14973C11.7423 9.00255 11.605 8.78668 11.4774 8.57081C11.3204 8.30588 11.1831 8.04095 11.0457 7.76621C11.0348 7.743 11.0242 7.71986 11.0137 7.69678C10.8525 7.34146 10.3878 7.23682 10.1119 7.51273L4.54019 13.0844C4.41263 13.212 4.29488 13.4573 4.26545 13.6241L3.73559 17.3822C3.63746 18.0494 3.8239 18.6774 4.23601 19.0993C4.58925 19.4427 5.07986 19.6292 5.60972 19.6292C5.72746 19.6292 5.84521 19.6194 5.96296 19.5997L9.73084 19.0699C9.90746 19.0404 10.1528 18.9227 10.2705 18.7951L15.8346 13.2311C16.1124 12.9533 16.0078 12.4758 15.6469 12.3204C15.6309 12.3135 15.6148 12.3065 15.5985 12.2995Z" fill="#CACACA" />
                                </svg>
                                </span> */}
                                    <button
                                    onClick={() => {
                                        setEditingBanner(firstItemBanners[1]); // Set the banner to be edited
                                        setNewBannerLink(firstItemBanners[1].bannerLink); // Prefill the link
                                        setNewBaseImage(firstItemBanners[1].imageUrl); // Show the current image
                                        setNewBannerTitle(firstItemBanners[1].title); // Prefill the title
                                        setnewBannerType('main banner 2'); // Prefill the type
                                        handleShow1(); // Open the second Offcanvas
                                    }}
                                    className="edit-icon"
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                        <path d="M20.817 22.5728H3.15498C2.75268 22.5728 2.41907 22.2391 2.41907 21.8368C2.41907 21.4345 2.75268 21.1009 3.15498 21.1009H20.817C21.2193 21.1009 21.5529 21.4345 21.5529 21.8368C21.5529 22.2391 21.2193 22.5728 20.817 22.5728Z" fill="#CACACA" />
                                        <path d="M18.8742 4.40057C16.9706 2.497 15.1063 2.44794 13.1536 4.40057L11.9664 5.58785C11.8683 5.68597 11.829 5.84296 11.8683 5.98034C12.614 8.58057 14.6942 10.6608 17.2944 11.4065C17.3336 11.4163 17.3729 11.4261 17.4121 11.4261C17.5201 11.4261 17.6182 11.3869 17.6967 11.3084L18.8742 10.1211C19.8456 9.15949 20.3166 8.22733 20.3166 7.28536C20.3264 6.31395 19.8554 5.37198 18.8742 4.40057Z" fill="#CACACA" />
                                        <path d="M15.5282 12.2994C15.2436 12.162 14.9689 12.0246 14.7039 11.8677C14.4881 11.7401 14.282 11.6027 14.076 11.4555C13.9092 11.3476 13.7129 11.1906 13.5265 11.0336C13.5069 11.0238 13.4382 10.9649 13.3597 10.8864C13.0359 10.6117 12.6728 10.2585 12.349 9.86596C12.3196 9.84634 12.2705 9.77765 12.2018 9.68934C12.1037 9.5716 11.9369 9.37535 11.7897 9.14967C11.672 9.00249 11.5346 8.78662 11.407 8.57075C11.25 8.30582 11.1127 8.04089 10.9753 7.76615C10.9645 7.74294 10.9538 7.7198 10.9434 7.69672C10.7821 7.34139 10.3174 7.23676 10.0415 7.51267L4.46981 13.0844C4.34226 13.2119 4.22451 13.4572 4.19507 13.624L3.66521 17.3821C3.56709 18.0493 3.75352 18.6773 4.16564 19.0992C4.51888 19.4427 5.00948 19.6291 5.53934 19.6291C5.65709 19.6291 5.77484 19.6193 5.89258 19.5997L9.66047 19.0698C9.83709 19.0404 10.0824 18.9226 10.2001 18.7951L15.7642 13.231C16.042 12.9532 15.9374 12.4757 15.5766 12.3203C15.5605 12.3134 15.5444 12.3064 15.5282 12.2994Z" fill="#CACACA" />
                                    </svg>

                                </button>
                            </div>
                        )}
                    </div>
                )}

                {secondItemBanners.length > 0 && (
                    <div className="firstrowbannerweb">
                        <div className="image-wrapper2nd" style={{ position: "relative" }}>
                            <img className="img-fluid imginnerchldsss imgthree" src={secondItemBanners[0].imageUrl} alt="" />
                            <div className="top-left-text">
                                <h4>{secondItemBanners[0].title}</h4>
                                <a href="#" className="shop-link">Shop Now
                                    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="22" viewBox="0 0 23 22" fill="none">
                                        <path d="M9.69998 15.3L14.2 10.8L9.69998 6.30005" stroke="#000" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </a>
                            </div>
                             
                            <button
                                    onClick={() => {
                                        setEditingBanner(secondItemBanners[0]); // Set the banner to be edited
                                        setNewBannerLink(secondItemBanners[0].bannerLink); // Prefill the link
                                        setNewBaseImage(secondItemBanners[0].imageUrl); // Show the current image
                                        setNewBannerTitle(secondItemBanners[0].title); // Prefill the title
                                        setnewBannerType('main banner 3'); // Prefill the type
                                        handleShow1(); // Open the second Offcanvas
                                    }}
                                    className="edit-icon"
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                        <path d="M20.817 22.5728H3.15498C2.75268 22.5728 2.41907 22.2391 2.41907 21.8368C2.41907 21.4345 2.75268 21.1009 3.15498 21.1009H20.817C21.2193 21.1009 21.5529 21.4345 21.5529 21.8368C21.5529 22.2391 21.2193 22.5728 20.817 22.5728Z" fill="#CACACA" />
                                        <path d="M18.8742 4.40057C16.9706 2.497 15.1063 2.44794 13.1536 4.40057L11.9664 5.58785C11.8683 5.68597 11.829 5.84296 11.8683 5.98034C12.614 8.58057 14.6942 10.6608 17.2944 11.4065C17.3336 11.4163 17.3729 11.4261 17.4121 11.4261C17.5201 11.4261 17.6182 11.3869 17.6967 11.3084L18.8742 10.1211C19.8456 9.15949 20.3166 8.22733 20.3166 7.28536C20.3264 6.31395 19.8554 5.37198 18.8742 4.40057Z" fill="#CACACA" />
                                        <path d="M15.5282 12.2994C15.2436 12.162 14.9689 12.0246 14.7039 11.8677C14.4881 11.7401 14.282 11.6027 14.076 11.4555C13.9092 11.3476 13.7129 11.1906 13.5265 11.0336C13.5069 11.0238 13.4382 10.9649 13.3597 10.8864C13.0359 10.6117 12.6728 10.2585 12.349 9.86596C12.3196 9.84634 12.2705 9.77765 12.2018 9.68934C12.1037 9.5716 11.9369 9.37535 11.7897 9.14967C11.672 9.00249 11.5346 8.78662 11.407 8.57075C11.25 8.30582 11.1127 8.04089 10.9753 7.76615C10.9645 7.74294 10.9538 7.7198 10.9434 7.69672C10.7821 7.34139 10.3174 7.23676 10.0415 7.51267L4.46981 13.0844C4.34226 13.2119 4.22451 13.4572 4.19507 13.624L3.66521 17.3821C3.56709 18.0493 3.75352 18.6773 4.16564 19.0992C4.51888 19.4427 5.00948 19.6291 5.53934 19.6291C5.65709 19.6291 5.77484 19.6193 5.89258 19.5997L9.66047 19.0698C9.83709 19.0404 10.0824 18.9226 10.2001 18.7951L15.7642 13.231C16.042 12.9532 15.9374 12.4757 15.5766 12.3203C15.5605 12.3134 15.5444 12.3064 15.5282 12.2994Z" fill="#CACACA" />
                                    </svg>

                                </button>
                        </div>
                        {secondItemBanners.length > 1 && (
                            <div className="image-wrapper2nd" style={{ position: "relative" }}>
                                <img className="img-fluid imginnerchldsss imgfour" src={secondItemBanners[1].imageUrl} alt="" />
                                <div className="top-left-text">
                                    <h4>{secondItemBanners[1].title}</h4>
                                    <a href={secondItemBanners[1].bannerLink} className="shop-link">Shop Now
                                        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="22" viewBox="0 0 23 22" fill="none">
                                            <path d="M9.69998 15.3L14.2 10.8L9.69998 6.30005" stroke="#000" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </a>
                                </div>
                                 
                                <button
                                    onClick={() => {
                                        setEditingBanner(secondItemBanners[1]); // Set the banner to be edited
                                        setNewBannerLink(secondItemBanners[1].bannerLink); // Prefill the link
                                        setNewBaseImage(secondItemBanners[1].imageUrl); // Show the current image
                                        setNewBannerTitle(secondItemBanners[1].title); // Prefill the title
                                        setnewBannerType('main banner 3'); // Prefill the type
                                        handleShow1(); // Open the second Offcanvas
                                    }}
                                    className="edit-icon"
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                        <path d="M20.817 22.5728H3.15498C2.75268 22.5728 2.41907 22.2391 2.41907 21.8368C2.41907 21.4345 2.75268 21.1009 3.15498 21.1009H20.817C21.2193 21.1009 21.5529 21.4345 21.5529 21.8368C21.5529 22.2391 21.2193 22.5728 20.817 22.5728Z" fill="#CACACA" />
                                        <path d="M18.8742 4.40057C16.9706 2.497 15.1063 2.44794 13.1536 4.40057L11.9664 5.58785C11.8683 5.68597 11.829 5.84296 11.8683 5.98034C12.614 8.58057 14.6942 10.6608 17.2944 11.4065C17.3336 11.4163 17.3729 11.4261 17.4121 11.4261C17.5201 11.4261 17.6182 11.3869 17.6967 11.3084L18.8742 10.1211C19.8456 9.15949 20.3166 8.22733 20.3166 7.28536C20.3264 6.31395 19.8554 5.37198 18.8742 4.40057Z" fill="#CACACA" />
                                        <path d="M15.5282 12.2994C15.2436 12.162 14.9689 12.0246 14.7039 11.8677C14.4881 11.7401 14.282 11.6027 14.076 11.4555C13.9092 11.3476 13.7129 11.1906 13.5265 11.0336C13.5069 11.0238 13.4382 10.9649 13.3597 10.8864C13.0359 10.6117 12.6728 10.2585 12.349 9.86596C12.3196 9.84634 12.2705 9.77765 12.2018 9.68934C12.1037 9.5716 11.9369 9.37535 11.7897 9.14967C11.672 9.00249 11.5346 8.78662 11.407 8.57075C11.25 8.30582 11.1127 8.04089 10.9753 7.76615C10.9645 7.74294 10.9538 7.7198 10.9434 7.69672C10.7821 7.34139 10.3174 7.23676 10.0415 7.51267L4.46981 13.0844C4.34226 13.2119 4.22451 13.4572 4.19507 13.624L3.66521 17.3821C3.56709 18.0493 3.75352 18.6773 4.16564 19.0992C4.51888 19.4427 5.00948 19.6291 5.53934 19.6291C5.65709 19.6291 5.77484 19.6193 5.89258 19.5997L9.66047 19.0698C9.83709 19.0404 10.0824 18.9226 10.2001 18.7951L15.7642 13.231C16.042 12.9532 15.9374 12.4757 15.5766 12.3203C15.5605 12.3134 15.5444 12.3064 15.5282 12.2994Z" fill="#CACACA" />
                                    </svg>

                                </button>
                            </div>
                        )}
                    </div>
                )}


                {thirdItemBanners.length > 0 && (

                    <div className="firstrowbannerweb" >
                        <div className="image-wrapper2nd" style={{ position: "relative" }}>
                            <img className="img-fluid imginnerchldsss imgfive" src={thirdItemBanners[0].imageUrl} alt="" />
                            <div className="top-left-text">
                                <h4>{thirdItemBanners[0].title}</h4>
                                <a href={thirdItemBanners[0].bannerLink} className="shop-link">Shop Now
                                    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="22" viewBox="0 0 23 22" fill="none">
                                        <path d="M9.69998 15.3L14.2 10.8L9.69998 6.30005" stroke="#000" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </a>
                            </div>
                            <button
                                    onClick={() => {
                                        setEditingBanner(thirdItemBanners[0]); // Set the banner to be edited
                                        setNewBannerLink(thirdItemBanners[0].bannerLink); // Prefill the link
                                        setNewBaseImage(thirdItemBanners[0].imageUrl); // Show the current image
                                        setNewBannerTitle(thirdItemBanners[0].title); // Prefill the title
                                        setnewBannerType('main banner 6'); // Prefill the type
                                        handleShow1(); // Open the second Offcanvas
                                    }}
                                    className="edit-icon"
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                        <path d="M20.817 22.5728H3.15498C2.75268 22.5728 2.41907 22.2391 2.41907 21.8368C2.41907 21.4345 2.75268 21.1009 3.15498 21.1009H20.817C21.2193 21.1009 21.5529 21.4345 21.5529 21.8368C21.5529 22.2391 21.2193 22.5728 20.817 22.5728Z" fill="#CACACA" />
                                        <path d="M18.8742 4.40057C16.9706 2.497 15.1063 2.44794 13.1536 4.40057L11.9664 5.58785C11.8683 5.68597 11.829 5.84296 11.8683 5.98034C12.614 8.58057 14.6942 10.6608 17.2944 11.4065C17.3336 11.4163 17.3729 11.4261 17.4121 11.4261C17.5201 11.4261 17.6182 11.3869 17.6967 11.3084L18.8742 10.1211C19.8456 9.15949 20.3166 8.22733 20.3166 7.28536C20.3264 6.31395 19.8554 5.37198 18.8742 4.40057Z" fill="#CACACA" />
                                        <path d="M15.5282 12.2994C15.2436 12.162 14.9689 12.0246 14.7039 11.8677C14.4881 11.7401 14.282 11.6027 14.076 11.4555C13.9092 11.3476 13.7129 11.1906 13.5265 11.0336C13.5069 11.0238 13.4382 10.9649 13.3597 10.8864C13.0359 10.6117 12.6728 10.2585 12.349 9.86596C12.3196 9.84634 12.2705 9.77765 12.2018 9.68934C12.1037 9.5716 11.9369 9.37535 11.7897 9.14967C11.672 9.00249 11.5346 8.78662 11.407 8.57075C11.25 8.30582 11.1127 8.04089 10.9753 7.76615C10.9645 7.74294 10.9538 7.7198 10.9434 7.69672C10.7821 7.34139 10.3174 7.23676 10.0415 7.51267L4.46981 13.0844C4.34226 13.2119 4.22451 13.4572 4.19507 13.624L3.66521 17.3821C3.56709 18.0493 3.75352 18.6773 4.16564 19.0992C4.51888 19.4427 5.00948 19.6291 5.53934 19.6291C5.65709 19.6291 5.77484 19.6193 5.89258 19.5997L9.66047 19.0698C9.83709 19.0404 10.0824 18.9226 10.2001 18.7951L15.7642 13.231C16.042 12.9532 15.9374 12.4757 15.5766 12.3203C15.5605 12.3134 15.5444 12.3064 15.5282 12.2994Z" fill="#CACACA" />
                                    </svg>

                                </button>
                        </div>
                        {thirdItemBanners.length > 1 && (
                            <div className="image-wrapper2nd" style={{ position: "relative" }}>
                                <img className="img-fluid imginnerchldsss imgsix" src={thirdItemBanners[1].imageUrl} alt="" />
                                <div className="top-left-text">
                                    <h4>{thirdItemBanners[1].title}</h4>
                                    <a href={thirdItemBanners[1].bannerLink} className="shop-link">Shop Now
                                        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="22" viewBox="0 0 23 22" fill="none">
                                            <path d="M9.69998 15.3L14.2 10.8L9.69998 6.30005" stroke="#000" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </a>
                                </div>
                                <button
                                    onClick={() => {
                                        setEditingBanner(thirdItemBanners[1]); // Set the banner to be edited
                                        setNewBannerLink(thirdItemBanners[1].bannerLink); // Prefill the link
                                        setNewBaseImage(thirdItemBanners[1].imageUrl); // Show the current image
                                        setNewBannerTitle(thirdItemBanners[1].title); // Prefill the title
                                        setnewBannerType('main banner 4'); // Prefill the type
                                        handleShow1(); // Open the second Offcanvas

                                    }}
                                    className="edit-icon"
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                        <path d="M20.817 22.5728H3.15498C2.75268 22.5728 2.41907 22.2391 2.41907 21.8368C2.41907 21.4345 2.75268 21.1009 3.15498 21.1009H20.817C21.2193 21.1009 21.5529 21.4345 21.5529 21.8368C21.5529 22.2391 21.2193 22.5728 20.817 22.5728Z" fill="#CACACA" />
                                        <path d="M18.8742 4.40057C16.9706 2.497 15.1063 2.44794 13.1536 4.40057L11.9664 5.58785C11.8683 5.68597 11.829 5.84296 11.8683 5.98034C12.614 8.58057 14.6942 10.6608 17.2944 11.4065C17.3336 11.4163 17.3729 11.4261 17.4121 11.4261C17.5201 11.4261 17.6182 11.3869 17.6967 11.3084L18.8742 10.1211C19.8456 9.15949 20.3166 8.22733 20.3166 7.28536C20.3264 6.31395 19.8554 5.37198 18.8742 4.40057Z" fill="#CACACA" />
                                        <path d="M15.5282 12.2994C15.2436 12.162 14.9689 12.0246 14.7039 11.8677C14.4881 11.7401 14.282 11.6027 14.076 11.4555C13.9092 11.3476 13.7129 11.1906 13.5265 11.0336C13.5069 11.0238 13.4382 10.9649 13.3597 10.8864C13.0359 10.6117 12.6728 10.2585 12.349 9.86596C12.3196 9.84634 12.2705 9.77765 12.2018 9.68934C12.1037 9.5716 11.9369 9.37535 11.7897 9.14967C11.672 9.00249 11.5346 8.78662 11.407 8.57075C11.25 8.30582 11.1127 8.04089 10.9753 7.76615C10.9645 7.74294 10.9538 7.7198 10.9434 7.69672C10.7821 7.34139 10.3174 7.23676 10.0415 7.51267L4.46981 13.0844C4.34226 13.2119 4.22451 13.4572 4.19507 13.624L3.66521 17.3821C3.56709 18.0493 3.75352 18.6773 4.16564 19.0992C4.51888 19.4427 5.00948 19.6291 5.53934 19.6291C5.65709 19.6291 5.77484 19.6193 5.89258 19.5997L9.66047 19.0698C9.83709 19.0404 10.0824 18.9226 10.2001 18.7951L15.7642 13.231C16.042 12.9532 15.9374 12.4757 15.5766 12.3203C15.5605 12.3134 15.5444 12.3064 15.5282 12.2994Z" fill="#CACACA" />
                                    </svg>

                                </button>
                            </div>
                        )}
                    </div>
                )}
                {/* this is ui  */}




            </div>

             {/* ////// fulll */}
             
            <div className="bannerwebmainsite">
                <div className="firstrowbannerweb">

                    {forItemBanners.length > 0 &&  (

                        <div className="image-wrapper2nd" style={{ position: "relative" }} >
                            <img className="img-fluid imginnerchldsss imgone " src={forItemBanners[0].imageUrl} alt="" />
                            <div className="top-left-text">
                                <h4>{forItemBanners[0].title}</h4>
                                <a href={forItemBanners[0].bannerLink} className="shop-link">Shop Now
                                    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="22" viewBox="0 0 23 22" fill="none">
                                        <path d="M9.69998 15.3L14.2 10.8L9.69998 6.30005" stroke="#000" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </a>
                            </div>
                           
                            <div className="img-icons">
                                <button
                                    onClick={() => {
                                        setEditingBanner(forItemBanners[0]); // Set the banner to be edited
                                        setNewBannerLink(forItemBanners[0].bannerLink); // Prefill the link
                                        setNewBaseImage(forItemBanners[0].imageUrl); // Show the current image
                                        setNewBannerTitle(forItemBanners[0].title); // Prefill the title
                                        setnewBannerType('main banner 7'); // Prefill the type
                                        handleShow1(); // Open the second Offcanvas
                                    }}
                                    className="edit-icon"
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                        <path d="M20.817 22.5728H3.15498C2.75268 22.5728 2.41907 22.2391 2.41907 21.8368C2.41907 21.4345 2.75268 21.1009 3.15498 21.1009H20.817C21.2193 21.1009 21.5529 21.4345 21.5529 21.8368C21.5529 22.2391 21.2193 22.5728 20.817 22.5728Z" fill="#CACACA" />
                                        <path d="M18.8742 4.40057C16.9706 2.497 15.1063 2.44794 13.1536 4.40057L11.9664 5.58785C11.8683 5.68597 11.829 5.84296 11.8683 5.98034C12.614 8.58057 14.6942 10.6608 17.2944 11.4065C17.3336 11.4163 17.3729 11.4261 17.4121 11.4261C17.5201 11.4261 17.6182 11.3869 17.6967 11.3084L18.8742 10.1211C19.8456 9.15949 20.3166 8.22733 20.3166 7.28536C20.3264 6.31395 19.8554 5.37198 18.8742 4.40057Z" fill="#CACACA" />
                                        <path d="M15.5282 12.2994C15.2436 12.162 14.9689 12.0246 14.7039 11.8677C14.4881 11.7401 14.282 11.6027 14.076 11.4555C13.9092 11.3476 13.7129 11.1906 13.5265 11.0336C13.5069 11.0238 13.4382 10.9649 13.3597 10.8864C13.0359 10.6117 12.6728 10.2585 12.349 9.86596C12.3196 9.84634 12.2705 9.77765 12.2018 9.68934C12.1037 9.5716 11.9369 9.37535 11.7897 9.14967C11.672 9.00249 11.5346 8.78662 11.407 8.57075C11.25 8.30582 11.1127 8.04089 10.9753 7.76615C10.9645 7.74294 10.9538 7.7198 10.9434 7.69672C10.7821 7.34139 10.3174 7.23676 10.0415 7.51267L4.46981 13.0844C4.34226 13.2119 4.22451 13.4572 4.19507 13.624L3.66521 17.3821C3.56709 18.0493 3.75352 18.6773 4.16564 19.0992C4.51888 19.4427 5.00948 19.6291 5.53934 19.6291C5.65709 19.6291 5.77484 19.6193 5.89258 19.5997L9.66047 19.0698C9.83709 19.0404 10.0824 18.9226 10.2001 18.7951L15.7642 13.231C16.042 12.9532 15.9374 12.4757 15.5766 12.3203C15.5605 12.3134 15.5444 12.3064 15.5282 12.2994Z" fill="#CACACA" />
                                    </svg>

                                </button>
                                
                            </div>

                        </div>
                    )}


                </div>
            </div>
             <div className="bannerwebmainsite">
                <div className="firstrowbannerweb">

                    {forItemBanners.length > 1 &&  (

                        <div className="image-wrapper2nd" style={{ position: "relative" }} >
                            <img className="img-fluid imginnerchldsss imgone " src={forItemBanners[1].imageUrl} alt="" />
                            <div className="top-left-text">
                                <h4>{forItemBanners[1].title}</h4>
                                <a href={forItemBanners[1].bannerLink} className="shop-link">Shop Now
                                    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="22" viewBox="0 0 23 22" fill="none">
                                        <path d="M9.69998 15.3L14.2 10.8L9.69998 6.30005" stroke="#000" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </a>
                            </div>
                           
                            <div className="img-icons">
                                <button
                                    onClick={() => {
                                        setEditingBanner(forItemBanners[1]); // Set the banner to be edited
                                        setNewBannerLink(forItemBanners[1].bannerLink); // Prefill the link
                                        setNewBaseImage(forItemBanners[1].imageUrl); // Show the current image
                                        setNewBannerTitle(forItemBanners[1].title); // Prefill the title
                                        setnewBannerType('main banner 8'); // Prefill the type
                                        handleShow1(); // Open the second Offcanvas
                                    }}
                                    className="edit-icon"
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                        <path d="M20.817 22.5728H3.15498C2.75268 22.5728 2.41907 22.2391 2.41907 21.8368C2.41907 21.4345 2.75268 21.1009 3.15498 21.1009H20.817C21.2193 21.1009 21.5529 21.4345 21.5529 21.8368C21.5529 22.2391 21.2193 22.5728 20.817 22.5728Z" fill="#CACACA" />
                                        <path d="M18.8742 4.40057C16.9706 2.497 15.1063 2.44794 13.1536 4.40057L11.9664 5.58785C11.8683 5.68597 11.829 5.84296 11.8683 5.98034C12.614 8.58057 14.6942 10.6608 17.2944 11.4065C17.3336 11.4163 17.3729 11.4261 17.4121 11.4261C17.5201 11.4261 17.6182 11.3869 17.6967 11.3084L18.8742 10.1211C19.8456 9.15949 20.3166 8.22733 20.3166 7.28536C20.3264 6.31395 19.8554 5.37198 18.8742 4.40057Z" fill="#CACACA" />
                                        <path d="M15.5282 12.2994C15.2436 12.162 14.9689 12.0246 14.7039 11.8677C14.4881 11.7401 14.282 11.6027 14.076 11.4555C13.9092 11.3476 13.7129 11.1906 13.5265 11.0336C13.5069 11.0238 13.4382 10.9649 13.3597 10.8864C13.0359 10.6117 12.6728 10.2585 12.349 9.86596C12.3196 9.84634 12.2705 9.77765 12.2018 9.68934C12.1037 9.5716 11.9369 9.37535 11.7897 9.14967C11.672 9.00249 11.5346 8.78662 11.407 8.57075C11.25 8.30582 11.1127 8.04089 10.9753 7.76615C10.9645 7.74294 10.9538 7.7198 10.9434 7.69672C10.7821 7.34139 10.3174 7.23676 10.0415 7.51267L4.46981 13.0844C4.34226 13.2119 4.22451 13.4572 4.19507 13.624L3.66521 17.3821C3.56709 18.0493 3.75352 18.6773 4.16564 19.0992C4.51888 19.4427 5.00948 19.6291 5.53934 19.6291C5.65709 19.6291 5.77484 19.6193 5.89258 19.5997L9.66047 19.0698C9.83709 19.0404 10.0824 18.9226 10.2001 18.7951L15.7642 13.231C16.042 12.9532 15.9374 12.4757 15.5766 12.3203C15.5605 12.3134 15.5444 12.3064 15.5282 12.2994Z" fill="#CACACA" />
                                    </svg>

                                </button>
                                
                            </div>

                        </div>
                    )}


                </div>
            </div>
      {/* full */}
     
         {/* ////////////////////////////////////////////////////////////////////////////////// FOR CREATEING BANNER OFFCANVAS */}

            {/* <div className="bannersitemanagmentoffcanvas">
                <div className="chlimgselect">

                    <div className="item-upload">
                        <ul className="list-inline ">
                            <li className="list-inline-item">

                                <label for="" className="">
                                    {baseImage ? (
                                        <div className="uploaded-img-wrapper">
                                            <img
                                                src={baseImage}
                                                alt="img"
                                                className="img-fluid upload-img"
                                            />

                                        </div>


                                    ) : (
                                        < div className=''>
                                            {accountImage ? (
                                                <img
                                                    src={accountImage}
                                                    alt="img"
                                                    className="img-fluid brdr-img"
                                                />
                                            ) : (
                                                <div className='imguploadchldsss'>
                                                    <svg onClick={handleShow} xmlns="http://www.w3.org/2000/svg" width="51" height="51" viewBox="0 0 51 51" fill="none">
                                                        <g clip-path="url(#clip0_7433_6019)">
                                                            <path d="M25.5211 0.6604C11.7353 0.6604 0.521118 11.8746 0.521118 25.6604C0.521118 39.4462 11.7353 50.6604 25.5211 50.6604C39.307 50.6604 50.5211 39.4443 50.5211 25.6604C50.5211 11.8765 39.307 0.6604 25.5211 0.6604ZM25.5211 46.7875C13.8732 46.7875 4.39407 37.3103 4.39407 25.6604C4.39407 14.0105 13.8732 4.53335 25.5211 4.53335C37.1691 4.53335 46.6482 14.0105 46.6482 25.6604C46.6482 37.3103 37.171 46.7875 25.5211 46.7875Z" fill="#767676" />
                                                            <path d="M35.2035 23.5496H27.4576V15.8037C27.4576 14.7348 26.592 13.8672 25.5211 13.8672C24.4502 13.8672 23.5846 14.7348 23.5846 15.8037V23.5496H15.8387C14.7678 23.5496 13.9022 24.4172 13.9022 25.4861C13.9022 26.5551 14.7678 27.4227 15.8387 27.4227H23.5846V35.1686C23.5846 36.2375 24.4502 37.1051 25.5211 37.1051C26.592 37.1051 27.4576 36.2375 27.4576 35.1686V27.4227H35.2035C36.2744 27.4227 37.1401 26.5551 37.1401 25.4861C37.1401 24.4172 36.2744 23.5496 35.2035 23.5496Z" fill="#767676" />
                                                        </g>
                                                        <defs>
                                                            <clipPath id="clip0_7433_6019">
                                                                <rect width="50" height="50" fill="white" transform="translate(0.521118 0.6604)" />
                                                            </clipPath>
                                                        </defs>
                                                    </svg>
                                                    <h4 className="">
                                                        Add Image
                                                    </h4>
                                                    <p>
                                                        Size 1125px by 221px
                                                    </p>
                                                </div>
                                            )}

                                        </div>
                                    )}
                                </label>

                            </li>
                        </ul>
                    </div>


                </div>
            </div> */}

                     {/* ////////////////////////////////////////////////////////////////////////////////// FOR CREATEING BANNER END */}

{/*             
            <div className="bannersitemanagmentoffcanvas">
                <div className="chlimgselect">

                    <div className="item-upload">
                        <ul className="list-inline ">
                            <li className="list-inline-item">
                                <input
                                    id="upload"
                                    type="file"
                                    className="d-none"
                                    onChange={uploadImages}
                                />
                                <label for="upload" className="">
                                    {baseImage ? (
                                        <div className="uploaded-img-wrapper">
                                            <img
                                                src={baseImage}
                                                alt="img"
                                                className="img-fluid upload-img"
                                            />
                                            <div className="img-icons">
                                                <button onClick={handleShow} className="edit-icon">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                                        <path d="M20.817 22.5728H3.15498C2.75268 22.5728 2.41907 22.2391 2.41907 21.8368C2.41907 21.4345 2.75268 21.1009 3.15498 21.1009H20.817C21.2193 21.1009 21.5529 21.4345 21.5529 21.8368C21.5529 22.2391 21.2193 22.5728 20.817 22.5728Z" fill="#CACACA" />
                                                        <path d="M18.8742 4.40057C16.9706 2.497 15.1063 2.44794 13.1536 4.40057L11.9664 5.58785C11.8683 5.68597 11.829 5.84296 11.8683 5.98034C12.614 8.58057 14.6942 10.6608 17.2944 11.4065C17.3336 11.4163 17.3729 11.4261 17.4121 11.4261C17.5201 11.4261 17.6182 11.3869 17.6967 11.3084L18.8742 10.1211C19.8456 9.15949 20.3166 8.22733 20.3166 7.28536C20.3264 6.31395 19.8554 5.37198 18.8742 4.40057Z" fill="#CACACA" />
                                                        <path d="M15.5282 12.2994C15.2436 12.162 14.9689 12.0246 14.7039 11.8677C14.4881 11.7401 14.282 11.6027 14.076 11.4555C13.9092 11.3476 13.7129 11.1906 13.5265 11.0336C13.5069 11.0238 13.4382 10.9649 13.3597 10.8864C13.0359 10.6117 12.6728 10.2585 12.349 9.86596C12.3196 9.84634 12.2705 9.77765 12.2018 9.68934C12.1037 9.5716 11.9369 9.37535 11.7897 9.14967C11.672 9.00249 11.5346 8.78662 11.407 8.57075C11.25 8.30582 11.1127 8.04089 10.9753 7.76615C10.9645 7.74294 10.9538 7.7198 10.9434 7.69672C10.7821 7.34139 10.3174 7.23676 10.0415 7.51267L4.46981 13.0844C4.34226 13.2119 4.22451 13.4572 4.19507 13.624L3.66521 17.3821C3.56709 18.0493 3.75352 18.6773 4.16564 19.0992C4.51888 19.4427 5.00948 19.6291 5.53934 19.6291C5.65709 19.6291 5.77484 19.6193 5.89258 19.5997L9.66047 19.0698C9.83709 19.0404 10.0824 18.9226 10.2001 18.7951L15.7642 13.231C16.042 12.9532 15.9374 12.4757 15.5766 12.3203C15.5605 12.3134 15.5444 12.3064 15.5282 12.2994Z" fill="#CACACA" />
                                                    </svg>
                                                </button>
                                                <button className="delete-icon">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                                                        <path d="M21.1391 6.11769C19.5594 5.9607 17.9796 5.84295 16.39 5.75464V5.74483L16.1742 4.46924C16.027 3.56652 15.8111 2.21243 13.5151 2.21243H10.9443C8.65802 2.21243 8.44215 3.50764 8.28516 4.45943L8.0791 5.71539C7.16657 5.77426 6.25403 5.83314 5.3415 5.92145L3.33981 6.11769C2.92769 6.15694 2.63333 6.51999 2.67258 6.92229C2.71182 7.32459 3.06506 7.61896 3.47718 7.57971L5.47887 7.38347C10.6205 6.87323 15.8013 7.06947 21.0018 7.58952C21.0312 7.58952 21.0508 7.58952 21.0803 7.58952C21.4531 7.58952 21.7769 7.30497 21.8162 6.92229C21.8456 6.51999 21.5513 6.15694 21.1391 6.11769Z" fill="#E15151" />
                                                        <path d="M19.3337 8.97304C19.0982 8.72773 18.7744 8.59036 18.4408 8.59036H6.03813C5.70452 8.59036 5.3709 8.72773 5.14522 8.97304C4.91954 9.21834 4.79198 9.55196 4.81161 9.89539L5.41997 19.9627C5.5279 21.4542 5.66527 23.3185 9.08973 23.3185H15.3892C18.8136 23.3185 18.951 21.464 19.0589 19.9627L19.6673 9.9052C19.6869 9.55196 19.5594 9.21834 19.3337 8.97304ZM13.8683 18.4026H10.6008C10.1985 18.4026 9.8649 18.069 9.8649 17.6667C9.8649 17.2644 10.1985 16.9307 10.6008 16.9307H13.8683C14.2706 16.9307 14.6042 17.2644 14.6042 17.6667C14.6042 18.069 14.2706 18.4026 13.8683 18.4026ZM14.6925 14.4777H9.7864C9.3841 14.4777 9.05048 14.1441 9.05048 13.7418C9.05048 13.3395 9.3841 13.0059 9.7864 13.0059H14.6925C15.0948 13.0059 15.4284 13.3395 15.4284 13.7418C15.4284 14.1441 15.0948 14.4777 14.6925 14.4777Z" fill="#E15151" />
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>


                                    ) : (
                                        < div className=''>
                                            {accountImage ? (
                                                <img
                                                    src={accountImage}
                                                    alt="img"
                                                    className="img-fluid brdr-img"
                                                />
                                            ) : (
                                                <div className='imguploadchldsss'>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="55" height="54" viewBox="0 0 55 54" fill="none">
                                                        <g clip-path="url(#clip0_7243_43912)">
                                                            <path d="M42.5802 46.2316H33.9297H31.6003H31.0973V34.6284H34.8921C35.8545 34.6284 36.4231 33.5348 35.8545 32.7474L28.4726 22.5331C28.0024 21.8769 27.0291 21.8769 26.5588 22.5331L19.177 32.7474C18.6083 33.5348 19.166 34.6284 20.1393 34.6284H23.9342V46.2316H23.4311H21.1017H11.0733C5.3319 45.9144 0.76062 40.5448 0.76062 34.7268C0.76062 30.7133 2.9369 27.2137 6.16304 25.3218C5.86776 24.5235 5.71466 23.6704 5.71466 22.7737C5.71466 18.6727 9.02829 15.359 13.1293 15.359C14.0151 15.359 14.8682 15.5121 15.6665 15.8074C18.0396 10.7768 23.1577 7.28821 29.1069 7.28821C36.8059 7.29914 43.1488 13.1937 43.8706 20.7068C49.787 21.7238 54.2817 27.2028 54.2817 33.4035C54.2817 40.0308 49.1199 45.7722 42.5802 46.2316Z" fill="#767676" />
                                                        </g>
                                                        <defs>
                                                            <clipPath id="clip0_7243_43912">
                                                                <rect width="53.5211" height="53.5211" fill="white" transform="translate(0.76062)" />
                                                            </clipPath>
                                                        </defs>
                                                    </svg>
                                                    <h4 className="innercntuploadsss">
                                                        Drag & Drop or <span>Browse</span>
                                                    </h4>
                                                    <p>
                                                        Size 380px by 286px
                                                    </p>
                                                </div>
                                            )}

                                         </div>
                                    )}
                                </label>
                                
                            </li>
                        </ul>
                    </div>


                </div>
            </div> */}





            <Offcanvas
                show={show}
                onHide={handleClose}
                className="bannersitemanagmentoffcanvasssss"
            >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Website Banner</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <div className="bannerss">
                        <h4>Banner Image</h4>
                        <div className="item-upload">
                            <ul className="list-inline ">
                                <li className="list-inline-item">
                                    <input
                                        id="uploadImage"
                                        type="file"
                                        className="d-none"
                                        onChange={handleImageChange}

                                    />
                                    <label htmlFor="uploadImage" className="">
                                        {newBaseImage ? (
                                            <div className="preview-container">
                                                <img src={newBaseImage} alt="Preview" className="img-preview" />
                                            </div>
                                        ) : (
                                            <div className='uploadimgprnt'>
                                                <img src="/assestsss/gallery-add.svg" className="img-fluid" />
                                                <h4>Drag your image here</h4>
                                                <p>(Size 16:9)</p>
                                            </div>
                                        )}


                                    </label>
                                </li>
                            </ul>
                        </div>
                        <div className="filedinput">
                            <input
                                type="text"
                                placeholder="Title"
                                value={newBannerTitle} onChange={(e) => setNewBannerTitle(e.target.value)}


                            />

                            <input
                                type="text"
                                placeholder="URL"
                                value={newBannerLink} onChange={(e) => setNewBannerLink(e.target.value)}

                            />
                            <input
                                type="type"
                                placeholder="type"
                                value={newBannerType} onChange={(e) => setnewBannerType(e.target.value)}

                            />

                        </div>
                        <div className="buttonss">
                            <button className="btn-1" >
                                Cancel
                            </button>
                            <button className="btn-1 btn-2"

                                onClick={uploadNewBanner}>
                                Save
                            </button>
                        </div>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>



            <Offcanvas
                show={show1}
                onHide={handleClose1}
                className="bannersitemanagmentoffcanvasssss"
            >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Website Banner</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <div className="bannerss">
                        <h4>{
                            newBannerType === 'main banner 1' ? 'Main Banner 1' 
                            : newBannerType === 'main banner 2' ? 'Main Banner 2'
                             :  newBannerType === 'main banner 3' ? 'Main Banner 3'
                              : newBannerType === 'main banner 4' ? 'Main Banner 4'
                               : newBannerType === 'main banner 5' ? 'Main Banner 5'
                               : newBannerType === 'main banner 6' ? 'Main Banner 6'
                                : newBannerType === 'main banner 7' ? 'Main Banner 7'
                                 : newBannerType === 'main banner 8' ? 'Main Banner 8' :  ''
                         }</h4>
                        <div className="item-upload">
                            <ul className="list-inline ">
                                <li className="list-inline-item">
                                    <input
                                        id="uploadImage"
                                        type="file"
                                        className="d-none"
                                        onChange={handleImageChange}
                                    />
                                    <label htmlFor="uploadImage" className="">
                                        {newBaseImage ? (
                                            <div className="preview-container">
                                                <img src={newBaseImage} alt="Preview" className="img-preview" />
                                            </div>
                                        ) : (
                                            <div className='uploadimgprnt'>
                                                <img src="/assestsss/gallery-add.svg" className="img-fluid" />
                                                <h4>Drag your image here</h4>
                                                <p>(Size 16:9)</p>
                                            </div>
                                        )}
                                    </label>
                                </li>
                            </ul>
                        </div>
                        <div className="filedinput">
                            <input
                                type="text"
                                placeholder="Title"
                                value={newBannerTitle}
                                onChange={(e) => setNewBannerTitle(e.target.value)}
                            />
                            <input
                                type="text"
                                placeholder="URL"
                                value={newBannerLink}
                                onChange={(e) => setNewBannerLink(e.target.value)}
                            />
                            {/* <input
                                type="type"
                                placeholder="type"
                                value={newBannerType} onChange={(e) => setnewBannerType(e.target.value)}

                            /> */}
                        </div>
                        <div className="buttonss">
                            <button className="btn-1" onClick={handleClose1}>
                                Cancel
                            </button>
                            <button className="btn-1 btn-2" onClick={handleUpdateBanner}>
                                Update-save
                            </button>
                        </div>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>



        </>
    )
}

export default Bannerwebsitemanagment